<template>
    <div class="animated fadeIn">

        <b-row class="mt-4">
            <b-col>
                <b-card header="Evolución de Altas y Bajas">
                    <members-subscription-evolution/>
                </b-card>
            </b-col>
        </b-row>

        <b-row class="py-2">

            <b-col md="6">
                <b-card v-if="mixinCheckPermission('CONNECTED_USERS')" header="Usuarios Conectados" class="w-100">
                    <v-client-table
                        class="dataTable" md="12" lg="12" sm="12"
                        :columns="columns"
                        :data="items"
                        :options="options"
                        :theme="theme" >
                        <template slot="uuid" slot-scope="props">
                            <router-link :to="{ path: '/admin/user/edit/'+props.row.uuid }">
                                <i class="fa fa-pencil"></i>
                            </router-link>
                        </template>
                    </v-client-table>
                </b-card>
            </b-col>

            <b-col md="6">

                <b-card header="Actividad Reciente" class="w-100">

                    <last-activity></last-activity>

                </b-card>

            </b-col>

        </b-row>

    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import Multiselect from 'vue-multiselect';
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import LastActivity from '@/components/activity/LastActivity';
    import MembersSubscriptionEvolution from '@/components/statistics/MembersSubscriptionEvolution';

    Vue.use(ClientTable);

    export default {
        name: 'dashboard',
        components: {
            ClientTable,
            Event,
            Multiselect,
            LastActivity,
            MembersSubscriptionEvolution
        },
        mounted(){
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
            this.getItems();
        },
        data: function () {
            return {
                topmenu: [
                    { name: 'Usuarios', path: '/admin/user/list', brand:'fa fa-users', permissions: ['USER_LIST']},
                    { name: 'Sedes', path: '/admin/headquarters/list',brand:'fa fa-building', permissions: ['HEADQUARTERS_LIST']},
                    { name: 'Departamentos', path: '/admin/departments/list',brand:'fa fa-archive', permissions: ['DEPARTMENT_LIST']},
                    { name: 'Convenios', path: '/admin/agreements/list',brand:'fa fa-ticket', permissions: ['AGREEMENT_LIST']},
                ],
                items_url : 'users/connected',

                items: [],

                columns: ['username', 'last_connection'],
                options: {
                    headings: {
                        username: 'Usuario',
                        last_connection: 'Última conexión'
                    },
                    sortable: ['username', 'last_connection'],
                    filterable: ['username', 'last_connection'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        methods: {

            getItems(){

                let self = this;
                let path = this.items_url;

                this.$_loadingMixin_showLoading();
                axios.get(path)
                    .then(function (response) {

                        if(response.status == "200"){
                            self.items = response.data
                            self.items.forEach( function(data) {
                                data['last_connection'] =  new Date(data['last_connection']).toLocaleDateString('en-GB');
                            });
                        }
                        self.$_loadingMixin_hideLoading();
                    })
                    .catch(function (error) {

                        self.$_loadingMixin_hideLoading();

                        if(error.response.status == 401){
                            self.showAuthorizedMsg()
                        }else{
                            self.showErrorMsg()
                        }
                    });
            },

            async getGeneral(url,varName) {

                let self = this;
                let path = url;

                try {

                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(path);
                    if(response.status == "200"){
                        this[varName] = response.data;
                    }
                    this.$_loadingMixin_hideLoading();
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    if(error.response.status == 401){
                        self.showAuthorizedMsg();
                    }else{
                        self.showErrorMsg();
                    }
                }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Registro almacenado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'Algo salió mal'
            },
            showAuthorizedMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'No tiene autorización'
            },

        }
    }
</script>
